import type { ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorBoundaryView } from './ErrorBoundaryPage';

export default function RootErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={() => <ErrorBoundaryView />}
      showDialog={false}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
